"use client";

import { useState } from "react";
import { ChevronDown, ChevronRight, Users } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import LeadsView from "./LeadsView";
import { cn } from "@/lib/utils";

interface CollapsibleLeadsViewProps {
  data: any;
  crmData: any;
  defaultCollapsed?: boolean;
}

const CollapsibleLeadsView = ({ 
  data, 
  crmData, 
  defaultCollapsed = false 
}: CollapsibleLeadsViewProps) => {
  const [isCollapsed, setIsCollapsed] = useState(defaultCollapsed);

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <Button
          variant="ghost"
          size="sm"
          onClick={() => setIsCollapsed(!isCollapsed)}
          className="flex items-center gap-2 text-muted-foreground hover:text-foreground"
        >
          {isCollapsed ? (
            <ChevronRight className="w-4 h-4" />
          ) : (
            <ChevronDown className="w-4 h-4" />
          )}
          <Users className="w-4 h-4" />
          <span className="font-medium">Investor Profiles</span>
          {data && data.length > 0 && (
            <span className="text-xs bg-muted px-2 py-0.5 rounded-full">
              {data.length}
            </span>
          )}
        </Button>
      </div>
      
      <div
        className={cn(
          "transition-all duration-300 ease-in-out",
          isCollapsed ? "max-h-0 overflow-hidden" : "max-h-none"
        )}
      >
        <LeadsView data={data} crmData={crmData} />
      </div>
    </div>
  );
};

export default CollapsibleLeadsView; 